module.exports = __webpack_public_path__ + "static/media/clouds.288b3d20.mp4";